<template>
  <div class="tt-notification-group">
    <Notification
      v-for="(nt, idx) in notices"
      :key="nt.id"
      :icon="nt.icon"
      :visible="nt.visible"
      :content="nt.content"
      :title="nt.title"
      :styles="{ top: `${idx * 80 + 15}px` }"
      :duration="nt.duration"
      :append-to-body="false"
      @click="nt.onClick"
      @open="nt.onOpen"
      @close="del(nt.id)"
    />
  </div>
</template>
<script>
import Notification from './Notification'
export default {
  components: { Notification },
  data() {
    return {
      notices: []
    }
  },
  methods: {
    add(notice) {
      const _notice = Object.assign(
        {
          visible: true,
          closable: false,
          duration: 4500,
          content: ''
        },
        notice
      )
      this.notices.push(_notice)
      return _notice.id
    },
    remove(key) {
      const target = this.notices.find(({ id }) => id === key)
      target.visible = false
    },
    del(uuid) {
      for (let i = 0; i < this.notices.length; i++) {
        if (this.notices[i].id === uuid) {
          this.notices[i].onClose()
          this.notices.splice(i, 1)
          break
        }
      }
    },
    removeAll() {
      this.notices.forEach(each => {
        each.visible = false
      })
    }
  }
}
</script>
